import React from "react";
import {
  DemoWorkbenchCard,
  DemoWorkbenchPill,
  DemoWorkbenchTable,
} from "@csk/demo-ui";

interface AuditFinding {
  readonly from?: string;
  readonly to?: string;
  readonly allowed_path?: readonly string[];
}

interface AuditPayload {
  readonly version?: string;
  readonly findings?: readonly AuditFinding[];
}

export function AuditPanel(props: {
  audit: AuditPayload | null;
}): React.JSX.Element {
  if (!props.audit) {
    return (
      <DemoWorkbenchCard
        title="Closure audit"
        right={<DemoWorkbenchPill>optional</DemoWorkbenchPill>}
      >
        <div className="text-sm text-slate-300">
          Provide <code>public/data/matrix-closure-audit.json</code>.
        </div>
      </DemoWorkbenchCard>
    );
  }
  const findings: readonly AuditFinding[] = Array.isArray(props.audit.findings)
    ? props.audit.findings
    : [];
  return (
    <DemoWorkbenchCard
      title="Matrix closure audit"
      right={
        <DemoWorkbenchPill>{props.audit.version ?? "v?"}</DemoWorkbenchPill>
      }
    >
      <DemoWorkbenchTable
        headers={["from", "to", "allowed_path"]}
        rows={findings.map((f) => [
          f.from ?? "",
          f.to ?? "",
          f.allowed_path ? f.allowed_path.join(" → ") : "—",
        ])}
      />
      <div className="text-xs text-slate-400 mt-3">
        Any allowed path from epistemic inputs to execution bridges should be
        treated as a δ-level security event requiring explicit admission and
        witnesses.
      </div>
    </DemoWorkbenchCard>
  );
}
